module.exports = __webpack_public_path__ + "img/g-blow.99559317.png";